import { BreakpointObserver } from '@angular/cdk/layout';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { Navigation, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { AnimationsService } from 'src/app/services/animations.service';
import { API } from 'src/app/services/api';
import { AulaOnlineService } from 'src/app/services/aula-online/aula-online.service';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { environment } from 'src/environments/environment';

interface MenuItem {
  image: string;
  text: string;
  url: string;
}


@Component({
  selector: 'app-simulados',
  templateUrl: './simulados.component.html',
  styleUrls: ['./simulados.component.scss']
})

export class SimuladosComponent implements OnInit {

  @Input() matriculaCompleta;
  cursoId: number = null;
  nomeAulaOnline: string = null;
  error: boolean = false;
  materias: any[] = [];
  matriculaId: number = null;
  isDesktop = false;
  aluno: string = null;
  
  menuItems: MenuItem[] = [
    { image: '../../../assets/home.png', text: 'Home', url:'initial' },
    { image: '../../../assets/minhas_aulas2.png', text: 'Minhas aulas', url:'disciplinas' },
    { image: '../../../assets/icon_simulados.png', text: 'Simulado', url:'simulados' },
    { image: '../../../assets/financeiro2.png', text: 'Financeiro', url:'alunos/matricula-aluno/aluno-financeiro-contrato' },
    { image: '../../../assets/documentos2.png', text: 'Documentos', url:'alunos/matricula-aluno/aluno-documentos' },
    { image: '../../../assets/conteudo.png', text: 'Conteúdo' , url:'alunos/matricula-aluno/conteudo-digital'},
    { image: '../../../assets/whatsapp_icon2.png', text: 'Canal WhatsApp', url:'whatsapp' },
    { image: '../../../assets/youtube2.png', text: 'YouTube', url: 'videos' },
    // { image: '../../../assets/eja_encceja2.png', text: 'Provas', url: 'alunos/eja-encceja' },
    { image: '../../../assets/sair.png', text: 'Sair', url: 'login' },
  ];

   
    
  logoLocalStorage = "";
  cursoLocalStorage = "";
  unidadeLocalStorage = "";
  matriculaCompletaStorage = "";

  constructor(
    private aulaOnlineService: AulaOnlineService,
    private router: Router,
    private breakpointObserver: BreakpointObserver,
    private http: HttpClient,
    private animationsService: AnimationsService,
    private errorHandlerService: ErrorHandlerService
  ) {
    
    // Get State
    this.logoLocalStorage = window.localStorage.getItem('logoLocalStorage');
    this.cursoLocalStorage = window.localStorage.getItem('cursoLocalStorage');
    this.unidadeLocalStorage = window.localStorage.getItem('unidadeLocalStorage');
    this.cursoId = parseInt(window.localStorage.getItem('cursoIdLocalStorage'));
    this.matriculaCompletaStorage = JSON.parse(window.localStorage.getItem('matriculaCompletaStorage'));  
    this.matriculaId = parseInt(window.localStorage.getItem('matriculaIdLocalStorage'))
    

    const currentNavigation: Navigation = this.router.getCurrentNavigation();
    if (currentNavigation && currentNavigation.extras && currentNavigation.extras.state) {
      const state = currentNavigation.extras.state;
      this.matriculaCompleta = state.matriculaCompleta;
      this.matriculaId = state.matriculaId;
      // this.cursoId = parseInt(window.localStorage.getItem('cursoIdLocalStorage'));
    }
   }

  ngOnInit(): void {
    window.localStorage.setItem('videosLocalStorage', 'false');
    this.aluno = window.localStorage.getItem('alunoStorage');
    const nomes = this.aluno.split(" ");
    const primeiroNome = nomes[0];
    const ultimoNome = nomes[nomes.length - 1];
    this.aluno = primeiroNome + ' ' + ultimoNome
    
    this.breakpointObserver.observe(['(min-width: 768px)']).subscribe(result => {
      this.isDesktop = result.matches;
    });

    this.getAulas(this.cursoId)

  }

  visualizaAula(matriculaId: number, materiaId: string): void{
    window.localStorage.setItem('materiaIdLocalStorage', materiaId);
    window.localStorage.setItem('materiaIdStorage', materiaId);
    
    const materiaString = JSON.stringify(this.materias);
    window.localStorage.setItem('materiaStorage', materiaString);
    this.router.navigate(['/aulas']);
  }



  linkSeletor(url: string, aulaId: number): void {
    var cursoId = Number(window.localStorage.getItem('cursoIdLocalStorage'));
    switch (url) {
      case 'whatsapp':
        window.open("https://whatsapp.com/channel/0029Va56Dv72kNFxI2ufVE09");
        break;
      default:
        this.router.navigate([`/${url}`], { state: { aulaId } });
        break
    }
  }

  

  getAulas(id) {
    this.cursoId = this.matriculaCompleta?.cursoId;
    
    return new Promise((res, rej) => {
      this.aulaOnlineService.getMateriasPorCurso(id).subscribe(val => {
        if (val?.status === 'error') {
          this.error = true;
          rej();
          return;
        }
        
        this.materias = [{id: 236, nomeMateria: 'Simulados', ordenacao: 0, isDelete: false}] //val[0];
        
        this.nomeAulaOnline = val?.nomeMateria;
        res(val);
        return;
      });
    });
  }
}
